import stock from '@/api/stock/stock-in'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  locations: [],
  suppliers: [],
  products: [],
  purchaseTypes: [],
  branch_id: [],
  purchaseorders: [],
  vendor_id: [],
  location_id: [],
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ],
  isInActive: false
}

export const getters = {
  getProduct: state => ({ chosenProduct, search = '' } = {}) => {
    if (chosenProduct !== undefined) {
      return state.products
        // .filter(p =>
        //   !_.includes(chosenProduct.map(el => el.product_id), p.product_id)
        // )
        .filter(p =>
          search.split(' ').every((s) => p.product_name_en.toLowerCase().includes(s.toLowerCase())) ||
          search.split(' ').every((s) => p.barcode.toLowerCase().includes(s.toLowerCase()))
        ).slice(0, 400);
      // return state.products.filter(p => search.split(' ').every((s) => p.product_name_en.includes(s)));
    }
    return state.products.slice(0, 400)
  },
  findProduct: state => productId => {
    if (!productId) {
      return {
        barcode: null,
        product_name_en: null
      }
    }
    return state.products.find(p => p.product_id == productId)
  },
  getUom: state => productId => {
    return state.products
      .filter(p => p.product_id == productId)
      .map(el => el.uom_category.unit_of_measures)
      .flat()
  },
  isExpirable: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.is_expirable)
        .reduce((init, value) => (init = value), false)
    }
    return false
  },
  isDefaultUom: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.uom_category.unit_of_measures)
        .flat()
        .filter(d => d.is_default == true)
        .map(el => el.uom_id)
        .reduce((init, value) => (init = value))
    }
    return null
  },
  getCostPrice: state => ({ product_id, uom_id }) => {
    return state.products
      .filter(p => p.product_id == product_id)
      .reduce((i, v) => (i = v.sale_code), [])
      .filter(s => s.uom_id == uom_id)
      .reduce((i, v) => (i = v.product_price ? v.product_price.cost : 0), 0)
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_LOCATION(state, data) {
    state.locations = data
  },
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  SET_SUPPLIER(state, data) {
    state.suppliers = data
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_PURCHASEORDER(state, data) {
    state.purchaseorders = data
  },
  SET_IS_INACTIVE(state, value) {
    state.isInActive = value
  },
  SET_VENDOR(state, data) {
    state.vendor_id = data
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_PURCHASE_TYPE(state, data) {
    state.purchaseTypes = data
  },
  PUSH_NEW_PURCHASE_TYPE(state, data) {
    // if not exists
    let exist = state.purchaseTypes.find(c => c.purchase_type_id == data.purchase_type_id)
    if (!exist) {
      state.purchaseTypes.push(data)
    }
  },
  MERGE_PURCHASEORDER(state, data) {
    if (data) {
      let check = state.purchaseorders.filter(p => p.po_id == data.po_id).length
      if (!check) {
        state.purchaseorders.push(data)
      }
    }
  },
  CLEAR_SETUP(state) {
    state.locations = []
    state.suppliers = []
    state.products = []
    state.purchaseorders = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        vendor_id: context.state.vendor_id,
        filter: {
          search: context.state.search,
          location_id: context.state.location_id,
          date_between: _.join(context.state.dateRange, ','),
          is_active: context.state.isInActive
        }
      },
      attrubutes
    )
    return stock.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return stock.store(data)
  },
  update(context, { id, data }) {
    return stock.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await stock.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return stock.destroy(id)
  },
  toPdf(context, id) {
    return stock.toPdf(id)
  },
  async getVendor(context) {
    let response = await stock.vendor()
    return response
  },
  purchaseorderList(context, id) {
    return stock.purchaseorderList(id)
  },
  async fetchResource(context) {
    let var_locat = await stock.location()
    context.commit('SET_LOCATION', var_locat.data)
    let var_supplier = await stock.supplier()
    context.commit('SET_SUPPLIER', var_supplier.data)
    let var_product = await stock.product()
    context.commit('SET_PRODUCT', var_product.data)
    let var_purchase = await stock.purchaseorder()
    context.commit('SET_PURCHASEORDER', var_purchase.data)
    let va_purchase_type = await stock.purchaseType()
    context.commit('SET_PURCHASE_TYPE', va_purchase_type.data)
  },
  getFormViewModel(context, params = {}) {
    return stock.formViewModel({ params })
  },
  importExcel(context, data) {
    return stock.importExcel(data)
  }

}
